import e from"@mui/material/Collapse";import{jsx as s}from"react/jsx-runtime";function l({isOpen:o,...p}){return s(e,{...p,in:o})}export{l as a};
